import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import React from "react";
import logo from "../../assets/Header/TCS_C4L_LOGO.svg";
import appStoreBadge from "../../assets/Header/appStore.svg";
import playstoreBadge from "../../assets/Header/PlayStore.svg";
import { useNavigate } from "react-router-dom";
import { URL_ROUTES } from "../../routes/UrlList";

const Header = () => {
  const navigate = useNavigate()
  return (
    <AppBar position="static" elevation={2} sx={{ backgroundColor: "#171717" }}>
      <Toolbar
        sx={{
          justifyContent: { xs: "center", sm: "center", md: "space-between" },
          px: 4,
        }}
      >
        <Box sx={{ width: { md: 200 } }} />
        <Box
          component="img"
          src={logo}
          alt="Company Logo"
          sx={{
            height: 40,
            width: "auto",
            cursor: 'pointer'
          }}
          onClick={() => { navigate(URL_ROUTES.LANDING_SCREEN) }}
        />
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "flex" },
            gap: 1,
            width: { xs: 100, md: 200 },
            justifyContent: "flex-end",
          }}
        >
          <Box component="a" href="https://apps.apple.com/in/app/tcs-circle4life/id1593154523" target="_blank" rel="noopener noreferrer">
            <Box
              component="img"
              src={appStoreBadge}
              alt="app store link"
              sx={{
                height: 40,
                width: "auto",
              }}
            />
          </Box>
          <Box component="a" href="https://play.google.com/store/apps/details?id=com.tcs.circle4life" target="_blank" rel="noopener noreferrer">

            <Box
              component="img"
              src={playstoreBadge}
              alt="playstore link"
              sx={{
                height: 40,
                width: "auto",
              }}
            />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
